import React, { Component, Fragment } from "react";

import moment from "moment";
import { Icon } from "components";

class Incident extends Component {
  state = {
    open: false,
  };

  handleToggle = () => {
    const { open } = this.state;

    this.setState({ open: !open });
  };

  render() {
    const { open } = this.state;
    const { data } = this.props;

    return (
      <Fragment>
        <tr>
          <td>
            <b>{data.attributes.endpoint}</b>
          </td>
          <td>
            <b>{data.attributes.auth_user ? data.attributes.auth_user.user_inhabitant_name : ''}</b><br />
            <small>{data.attributes.auth_user ? data.attributes.auth_user.auth_user_id : ''}</small>
          </td>
          <td>{data.attributes.error}</td>
          <td>
            {moment(data.attributes.created_at).format("DD/MM/YYYY [às] HH:mm")}
          </td>
          <td>{data.attributes.status}</td>

          <td className="text-right">
            <button className="button-icon" onClick={this.handleToggle}>
              {open ? (
                <Icon name="minus" prefix="fa" />
              ) : (
                <Icon name="plus" prefix="fa" />
              )}
            </button>
          </td>
        </tr>
        {open && (
          <tr>
            <td colSpan="7" className="code-highlighter">
              <pre>{data.attributes.extra_data}</pre>
            </td>
          </tr>
        )}
      </Fragment>
    );
  }
}

export default Incident;
